import axios, { AxiosResponse } from "axios";
import { keycloakInterceptor } from "../auth/keycloakService";
import { ICidade, IEstado, IPais } from "../Interfaces/Localidades";
import { IApiCnpj, ICep } from "../Interfaces/DadosPrevicInterfaces";


const apiExternos = axios.create({
  baseURL: process.env.REACT_APP_URL_API_EXTERNOS,
});

apiExternos.interceptors.request.use(keycloakInterceptor);



export const obterPaises = ():Promise<AxiosResponse<IPais[], any>> => {
  return apiExternos.get<IPais[]>("/localidades/paises");
}

export const obterEstados = ():Promise<AxiosResponse<IEstado[], any>> => {
  return apiExternos.get("/localidades/estados");
}

export const obterMunicipios = (estado :string):Promise<AxiosResponse<ICidade[], any>> => {
  return apiExternos.get(`/localidades/estados/${estado}/municipios`);
}

export const consultarCep = (cep :string):Promise<AxiosResponse<ICep, any>> => {
  return apiExternos.get(`/cep/${cep}`);
}

export const consultarCnpj = (cnpj :string):Promise<AxiosResponse<IApiCnpj, any>> => {
  return apiExternos.get(`/cnpj/${cnpj}`);
}
